import Vue from 'vue'
import Vuex from 'vuex'
import axios, { AxiosResponse } from 'axios'
import { ConferenceDoctorUserProfile } from '@/types/api-docs'
import router from '@/router/member'
import Utils from '@/utils/utils'
import { Route } from 'vue-router'

Vue.use(Vuex)

interface DoctorState {
  profile: ConferenceDoctorUserProfile | null
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  queryParams?: any
  preRoute?: Route
}

const state: DoctorState = {
  profile: null,
  queryParams: undefined,
  preRoute: undefined,
}

export default new Vuex.Store({
  state,
  getters: {
    loginId: (state) => state.profile?.mail,
    isAuthenticated: (state) => {
      return state.profile != null
    },
    username: (state) => {
      return state.profile?.mail
    },
    conferenceName: (state) => {
      return state.profile?.conferenceName
    },
    conferencesId: (state) => {
      return state.profile?.conferencesId
    },
    organization: (state) => {
      return state.profile?.organization
    },
    preRoute: (state) => {
      return state.preRoute
    },
  },
  mutations: {
    updateLoginId(state, loginId) {
      if (state.profile != null) {
        state.profile.mail = loginId
      }
    },
    resetProfile(state) {
      state.profile = null
    },
    resetData(state) {
      state.profile = null
      state.queryParams = undefined
    },
    updateProfile(state, profile) {
      state.profile = profile
    },
    updateQueryParams(state, queryParams) {
      state.queryParams = queryParams
    },
    updatePreRoute(state, route) {
      state.preRoute = route
    },
  },
  actions: {
    async login({ commit }, authData) {
      const params = new URLSearchParams()
      params.append('loginId', authData.loginId)
      params.append('password', authData.password)

      let loginUrl = `${window.location.origin}/member/auth/login`
      if (window.location.search) {
        const queryParams = Utils.getQueryParams()
        commit('updateQueryParams', queryParams)
        loginUrl += window.location.search
      }

      await new Promise((resolve, reject) => {
        axios
          .post(loginUrl, params)
          .then(async (response) => {
            if (response !== undefined && (response as AxiosResponse).status === 200) {
              commit('updateLoginId', authData.loginId)
              resolve(response.data)
              await router.push('/member')
            } else {
              reject(new Error('login failed'))
            }
          })
          .catch(async (reason) => {
            reject(reason)
          })
      })
    },
    async logout({ commit }) {
      await new Promise((resolve, reject) => {
        axios
          .post(`${window.location.origin}/member/auth/logout`)
          .catch(async (reason) => {
            reject(reason)
          })
          .then(async (response) => {
            if (response !== undefined && (response as AxiosResponse).status === 200) {
              const queryParams = this.state.queryParams
              commit('resetData')
              resolve(response.data)
              await router.push({ path: '/member/login', query: queryParams })
            } else {
              reject(new Error('logout failed'))
            }
          })
      })
    },
    async getProfile({ commit }) {
      await new Promise((resolve, reject) => {
        axios
          .get(`${window.location.origin}/api/member/profile`)
          .catch(async (reason) => {
            commit('resetProfile')
            reject(reason)
          })
          .then(async (response) => {
            if (response !== undefined && (response as AxiosResponse).status === 200) {
              commit('updateProfile', response.data)
              resolve(response.data)
            } else {
              commit('resetProfile')
              reject(new Error('get profile failed'))
            }
          })
      })
    },
  },
  modules: {},
})
